// extracted by mini-css-extract-plugin
module.exports = {"commentDiv":"Comments_commentDiv__bhrJz","sectionImage":"Comments_sectionImage__dm52I","video":"Comments_video__orEbX"};